import {Actions, StateChanges} from './stateChanges'
import axios from 'axios'

const TYPE_AHEAD_API = '/typeaheadapi'
const SEARCH_API = '/api'
const SENTENCE_API  = '/sentenceapi'

axios.defaults.headers = {
//  'Access-Control-Allow-Origin': '*',        
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}
const axiosInstance = axios.create({timeout: 60000})
axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

const invalidInput = false
export default {
  [Actions.RUN_SEARCH]: function ({ commit, state }) {
    if (invalidInput) {
      console.log('Invalid input.')
      return
    }
    commit(StateChanges.SEARCH_RUNNING)
    state.currentIndex = 0
    if (axiosInstance.isCancel != undefined) {
      axiosInstance.isCancel()
    }     
    var textForApi = state.textForApiCall
    axiosInstance.get(SEARCH_API + '/'+encodeURIComponent(textForApi))
      .then(function (response) {        
        commit(StateChanges.SET_TEXT_FOR_API_CALL, response.data.clean_query)
        commit(StateChanges.SET_SEARCH_RESULTS, response.data)
        commit(StateChanges.SEARCH_COMPLETE)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.SEARCH_TIMED_OUT)
        } else {
          console.log(error)
          commit(StateChanges.SEARCH_FAILED)
        }
      })
    
  },
  [Actions.RUN_SENTENCE]: function ({ commit, state }) {
    if (invalidInput) {
      console.log('Invalid input.')
      return
    }
    commit(StateChanges.SENTENCE_SEARCH_RUNNING)
    if (axiosInstance.isCancel != undefined) {
      axiosInstance.isCancel()
    }     
    var textForApi = state.textForApiSentenceCall
    axiosInstance.get(SENTENCE_API + '/'+encodeURIComponent(textForApi))
      .then(function (response) {        
        commit(StateChanges.SET_SENTENCE_RESULTS, response.data)
        commit(StateChanges.SENTENCE_SEARCH_COMPLETE)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.SENTENCE_SEARCH_TIMED_OUT)
        } else {
          console.log(error)
          commit(StateChanges.SENTENCE_SEARCH_FAILED)
        }
      })
    
  },
  [Actions.RUN_TYPE_AHEAD]: function ({ commit, state }) {
    if (invalidInput) {
      console.log('Invalid input.')
      return
    }
    commit(StateChanges.TYPE_AHEAD_RUNNING)
    if (axiosInstance.isCancel != undefined) {
      axiosInstance.isCancel()
    }    
    var textForApi = state.textForApiCall
    axiosInstance.get(TYPE_AHEAD_API + '/'+encodeURIComponent(textForApi))
      .then(function (response) {        
        commit(StateChanges.SET_TEXT_FOR_API_CALL, response.data.clean_query)
        commit(StateChanges.SET_TYPE_AHEAD_RESULTS, response.data)
        commit(StateChanges.TYPE_AHEAD_COMPLETE)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.TYPE_AHEAD_TIMED_OUT)
        } else {
          console.log(error)
          commit(StateChanges.TYPE_AHEAD_FAILED)
        }
      })    
    }
  }
